import React from "react";
import PropTypes from "prop-types";

const StarRating = ({
  rating,
  totalStars,
  starSize,
  filledColor,
  emptyColor,
}) => {
  const filledStars = Math.floor(rating); // Number of full stars
  const percentageFill = (rating - filledStars) * 100; // Percentage to fill for the last star

  const stars = [];
  // Create stars based on the totalStars
  for (let i = 0; i < totalStars; i++) {
    if (i < filledStars) {
      stars.push(
        <span key={i} className="star" style={{ color: filledColor }}>
          ★
        </span>
      );
    } else if (i === filledStars && percentageFill !== 0) {
      stars.push(
        <span key={i} className="star" style={{ color: filledColor }}>
          <span
            className="star-part dark"
            style={{ width: `${percentageFill}%`, overflow: "hidden" }}
          >
            ★
          </span>
          <span className="star-part light" style={{ color: emptyColor }}>
            ☆
          </span>
        </span>
      );
    } else {
      stars.push(
        <span key={i} className="star" style={{ color: emptyColor }}>
          ☆
        </span>
      );
    }
  }

  return (
    <div className="star-rating" style={{ fontSize: starSize }}>
      {stars}
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  totalStars: PropTypes.number,
  starSize: PropTypes.string,
  filledColor: PropTypes.string,
  emptyColor: PropTypes.string,
};

StarRating.defaultProps = {
  totalStars: 5,
  starSize: "22px",
  filledColor: "gold",
  emptyColor: "lightgray",
};

export default StarRating;
